<template>
    <div class="language-select">
        <span style="display: inline-block;">Language</span>
        <el-select style="width: 90px;" v-if="$store.state.globalConfig" v-model="$store.state.globalConfig.language"
            size="mini" @change="languageChanged">
            <el-option v-for="item in internationalize" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    name: 'languageSelect',
    data() {
        return {
            internationalize: [{
                    label: "中文",
                    value: "zh_CN"
                },
                {
                    label: "English",
                    value: "en"
                }
            ],
        }
    },
    created() {
        this.$i18n.locale = this.$store.state.globalConfig.language;
    },
    methods: {
        languageChanged(value) {
            this.$store.commit("globalConfig", { language: value });
            this.$i18n.locale = value;
        }
    }
}
</script>

<style scoped lang="scss"></style>


// WEBPACK FOOTER //
// src/components/common/languageSelect.vue